import DatasetTable, { datasetTableColumns } from "@/components/DatasetTable/DatasetTable";
import EcoInventDatasetSelector from "@/components/EcoInventDatasetSelector/EcoInventDatasetSelector";
import PageButtonGroup from "@/components/PageButtonGroup/PageButtonGroup";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import PremiumExplore from "@/components/PremiumFeatureComponents/PremiumExplore";
import useTableStateUrl from "@/components/Table/hooks/useTableStateUrl";
import TableHeader from "@/components/TableHeader/TableHeader";
import useAnalytics from "@/hooks/useAnalytics";
import { useCompanyAccess } from "@/hooks/useCompanySettings";
import { useImpactDatasets } from "@/hooks/useEcoInventDatasets";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { extraColumn } from "./AllReferences";

export default function CustomReferences() {
  const analytics = useAnalytics();
  const navigate = useNavigate();
  const access = useCompanyAccess();
  const column = extraColumn(navigate);

  analytics.track("Custom References Overview Viewed");

  const columns = [
    ...datasetTableColumns.filter((x) => x.key !== "dataset_type"),
    ...(column ? [column] : []),
  ];

  const { pagination, filter, search, sort, onSearchFilterSortPaginate } = useTableStateUrl({
    columns,
    defaultPagination: { page: 1, pageSize: 20 },
  });

  const newSearch = { dataset_type: "custom", ...search };

  const { data, isLoading, isFetching } = useImpactDatasets({
    pagination,
    filter,
    search: newSearch,
    sort,
  });

  if (access && !access.includes("custom_impact_references")) {
    return <PremiumExplore title={"Custom"} />;
  }

  return (
    <div>
      <PageHeader
        title="Custom impact references"
        description="Create and manage your own impact references tailored to your specific materials or processes."
      />
      <div>
        <TableHeader
          left={
            <PageButtonGroup>
              <EcoInventDatasetSelector
                onSelect={(dataset) => navigate("/impact_references/custom/create/" + dataset.id)}
              >
                <Button>
                  <PlusOutlined />
                  Add custom impact reference
                </Button>
              </EcoInventDatasetSelector>
            </PageButtonGroup>
          }
        />
        <DatasetTable
          columns={columns}
          totalRows={data?.total_count}
          onSearchFilterSortPaginate={onSearchFilterSortPaginate}
          pagination={pagination}
          data={data?.datasets}
          filter={filter}
          search={search}
          sort={sort}
          loading={isLoading || isFetching}
          rowLink={(record) => `/impact_references/custom/${record.id}`}
        />
      </div>
    </div>
  );
}
